import axios from "axios"
import store from "../store"
import config from "./config"
import {TracFloState} from '../types/state'

const axiosSettings = {
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  // normally would want to cut off at 20 sec, but we have been having issues with PDF generation taking
  // enormous amounts of time, so we need to extend in order to prevent bad timeouts
  timeout: 60000,
}

const api = axios.create(axiosSettings)

let state: TracFloState

const handleChange = () => {
  state = store.getState()
}

store.subscribe(handleChange)

api.interceptors.request.use(
  function (axiosConfig) {
    // update with api base url
    axiosConfig.url = `${config.api.url}${axiosConfig.url}`
    // add user token if we have it
    if (state.user?.token) {
      axiosConfig.headers.Authorization = `Bearer ${state.user.token}`
    }
    // add company id if we have it
    if (state.company?.id) {
      axiosConfig.headers.company_id = state.company.id
    }
    return axiosConfig
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

export default api
